module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_4.830bc944.png";